import { useEffect, useState } from 'react';
import './RegistratieLinkModal.css';

function authFetch(url, options = {}) {
  const token = localStorage.getItem('ozel_token');
  return fetch(url, {
    ...options,
    headers: { ...(options.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    credentials: 'include',
  });
}

const STATUS = {
  open: { label: 'Open', cls: 'open' },
  gebruikt: { label: 'Ingevuld', cls: 'used' },
  verlopen: { label: 'Verlopen', cls: 'off' },
  ongeldig: { label: 'Ingetrokken', cls: 'off' },
};
const fmt = (d) => new Date(d).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' });

export default function RegistratieLinkModal({ onClose }) {
  const [label, setLabel] = useState('');
  const [created, setCreated] = useState(null);
  const [links, setLinks] = useState([]);
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');

  const load = () => authFetch('/api/registratie/links').then((r) => r.json()).then(setLinks).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const create = async (e) => {
    e.preventDefault();
    setBusy(true); setError(''); setCopied(false);
    try {
      const r = await authFetch('/api/registratie/links', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ label }),
      });
      if (!r.ok) throw new Error();
      setCreated(await r.json());
      setLabel('');
      load();
    } catch {
      setError('Link maken mislukt. Probeer opnieuw.');
    } finally {
      setBusy(false);
    }
  };

  const message = created
    ? `Hoi${created.label ? ` ${created.label.split(' ')[0]}` : ''}, via deze link kun je je aanmelden bij Özel Uitzendbureau. Vul je gegevens in en upload je ID, KvK en certificaten:\n${created.url}\n\nDe link werkt 7 dagen en is alleen voor jou.`
    : '';

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(message);
      setCopied(true);
    } catch {
      window.prompt('Kopieer de tekst:', message);
    }
  };

  const revoke = async (id) => {
    if (!window.confirm('Deze link intrekken? Hij werkt daarna niet meer.')) return;
    await authFetch(`/api/registratie/links/${id}`, { method: 'DELETE' });
    if (created?.id === id) setCreated(null);
    load();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content rl" onClick={(e) => e.stopPropagation()} role="dialog" aria-labelledby="rl-title">
        <div className="modal-header">
          <h3 id="rl-title">Registratielink</h3>
          <button className="modal-close" onClick={onClose} aria-label="Sluiten">✕</button>
        </div>

        <p className="rl-intro">
          Maak een link voor één persoon. Na het invullen staat hij in Medewerkers met het label <b>Nieuw</b>;
          zijn documenten staan bij Documenten. De link werkt één keer en 7 dagen.
        </p>

        <form className="rl-form" onSubmit={create}>
          <label>
            <span>Voor wie? (optioneel)</span>
            <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="bijv. Lyndon Lionar" maxLength={120} />
          </label>
          <button type="submit" className="rl-make" disabled={busy}>{busy ? 'Bezig…' : 'Link maken'}</button>
        </form>
        {error && <p className="rl-error">{error}</p>}

        {created && (
          <div className="rl-created">
            <div className="rl-url">{created.url}</div>
            <div className="rl-actions">
              <button type="button" onClick={copy}>{copied ? 'Gekopieerd ✓' : 'Kopieer bericht'}</button>
              <a href={`https://wa.me/?text=${encodeURIComponent(message)}`} target="_blank" rel="noopener noreferrer">
                Delen via WhatsApp
              </a>
            </div>
          </div>
        )}

        {links.length > 0 && (
          <div className="rl-history">
            <h4>Recente links</h4>
            <ul>
              {links.map((l) => (
                <li key={l.id}>
                  <span className="rl-who">{l.workerName || l.label || 'Zonder naam'}</span>
                  <span className={`rl-status ${STATUS[l.status]?.cls}`}>{STATUS[l.status]?.label}</span>
                  <span className="rl-date">{fmt(l.createdAt)}</span>
                  {l.status === 'open' ? (
                    <button type="button" className="rl-revoke" onClick={() => revoke(l.id)}>Intrekken</button>
                  ) : <span className="rl-revoke-placeholder" />}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
